export default "__VITE_ASSET__SasROu4p__";